import { clamp } from "core/util/MathUtils";
import { CourseWrapper, IEntry } from "../courseWrapper/CourseWrapper";
import { ID } from "../IEntity";
import { ITextStore } from "../ITextStore";

interface IProgramProgress {
	id?: ID;
	name?: string;
	total?: number;
	completed?: number;
}

interface IProgram {
	id: string | number;
	name: string;
	description?: string;

	progress?: IProgramProgress[];
	preTest?: IEntry;
	postTest?: IEntry;
}

export default class ProgramWrapper {

	private program: IProgram;

	constructor(program: IProgram) {
		this.program = program || {} as IProgram;
	}

	public getId(): ID { return this.program.id; }
	public getName(): string { return this.program.name; }
	public getDescription(): string { return this.program.description; }

	public getPreTest(): IEntry | null { return this.program.preTest; }
	public getPostTest(): IEntry | null { return this.program.postTest; }

	public getPreTestWrapper(): CourseWrapper | undefined {
		return this.getPreTest() ? CourseWrapper.forEntry(this.getPreTest()) : undefined;
	}

	public getPostTestWrapper(): CourseWrapper | undefined {
		return this.getPostTest() ? CourseWrapper.forEntry(this.getPostTest()) : undefined;
	}

	public getProgress(): IProgramProgress[] {
		return this.program.progress || [];
	}

	public getAggregateProgress(): IProgramProgress {
		return this.getProgress().reduce((a, c) => {
			if (c.total) {
				a.total += c.total;
				if (c.completed) {
					a.completed += c.completed;
				}
			}
			return a;
		}, {
			completed: 0,
			total: 0
		});
	}

	public getAggregateProgressPercent(): number {
		const p = this.getAggregateProgress();
		return p.total > 0 ? clamp(0, 1, (p.completed / p.total), 0) : 0;
	}

}



// WEBPACK FOOTER //
// ./src/common/entities/programWrapper/ProgramWrapper.ts